import { PipelineOperator } from '@/modules/pipelines/model/pipeline-alerts/pipeline-operator';

export const PIPELINE_NOTICE_TOPIC_KEY = 'petro-pipeline.notices';
export const PIPELINE_TAG_KEY = 'pipeline';

export function pipelineTagFilter(
  operator: PipelineOperator | undefined,
): Record<string, unknown> | undefined {
  if (!operator?._id) return undefined;
  return { [PIPELINE_TAG_KEY]: operator._id };
}

export function pipelineSubscriptionName(operator: PipelineOperator | undefined): string {
  if (!operator) return '';

  const name = operator.name?.trim();
  const owner = operator.owner?.trim();

  if (name && owner && name !== owner) return `${owner} — ${name}`;
  return name || owner || operator._id;
}
